// Actions
import { actions as notifyActions } from 'modules/notifications/actions'
import { actions as profileActions } from 'modules/profile/actions'

// types
import { Dispatch, APIAction, GetState, Loop } from 'types'

// Utils
import { downloadlink } from 'normalize'

const downloadWarning = (e: BeforeUnloadEvent) => {
  const downloadWarningText = 'Your download is being prepared. Closing this window will abort your download.'
  e.returnValue = downloadWarningText
  return downloadWarningText
}

export const actions = {
  fetchThenDownloadOrder: (orderId: number) => async (dispatch: Dispatch, getState: GetState) => {
    let notification: Notification | null = null
    window.addEventListener('beforeunload', downloadWarning)
    const {
      notifications: { entities },
    } = getState()
    const notificationsList = Object.keys(entities).map(id => entities[id])
    if (!notificationsList.some(x => x.icon === 'download')) {
      const { data } = (await dispatch(notifyActions.downloadStarting())) as { data: Notification }
      notification = data
    }

    return dispatch(actions.fetchOrderDownloadLink(orderId)).then(result => {
      window.removeEventListener('beforeunload', downloadWarning)
      const data = result.data.response
      const item = data?.entities?.downloadlinks[data.result]
      window.open(item.download_url, '_self')
      if (notification) {
        return dispatch(notifyActions.seenLocal(notification))
      }
      return Promise.resolve()
    })
  },

  fetchOrderDownloadLink: (orderId: number): APIAction => ({
    CALL_API: {
      type: 'FETCH_DOWNLOAD_ORDER_LINK',
      method: 'GET',
      endpoint: `/api/downloadorder/${orderId}/`,
      schema: downloadlink,
      requestKey: orderId,
      actionParams: { id: orderId },
    },
  }),

  waitForDownloadLinkThenDownload: (trackId: number, loop: Loop, filename: string) => async (dispatch: Dispatch, getState: GetState) => {
    let notification: Notification | null = null
    const {
      notifications: { entities },
    } = getState()
    const notificationsList = Object.keys(entities).map(id => entities[id])
    if (!notificationsList.some(x => x.icon === 'download')) {
      const { data } = (await dispatch(notifyActions.downloadStarting())) as { data: Notification }
      notification = data
    }

    return dispatch(actions.fetchWebSocketLink(trackId, loop, filename)).then(async result => {
      if (notification) {
        dispatch(notifyActions.seenLocal(notification))
      }
      dispatch(profileActions.fetchProfile()) // fetch profile to get new purchased_tracks

      if (result?.data && !result.data.error) {
        window.open(result.data.response.url, '_self')
        return Promise.resolve()
      }
      return dispatch(notifyActions.downloadError())
    })
  },

  fetchWebSocketLink: (trackId: number, loop: Loop, filename: string) => (dispatch: Dispatch, getState: GetState) =>
    dispatch({
      CALL_API: {
        type: 'FETCH_WEBSOCKET_LINK',
        method: 'POST',
        endpoint: '/api/download/',
        requestKey: `${trackId}${loop ? `-${loop.beat_start}:${loop.beat_count}` : ''}`,
        actionParams: {
          profileId: getState().auth.profileId,
        },
        data: {
          audiofile_id: trackId,
          filename,
          ...((loop?.beat_start === 0 || loop?.beat_start) && {
            beat_start: loop.beat_start,
          }),
          ...((loop?.beat_count === 0 || loop?.beat_count) && {
            beat_length: loop.beat_count,
          }),
          url: `${getState().router.location.pathname}?${getState().router.location.search}`,
        },
      },
    }),
}
